import { IRatingState } from "@edp-store/state/rating.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const ratingSelector = (state: IAppState) => state.rating;

export const getRatingStatus = createSelector(ratingSelector, (state: IRatingState) => state.rating);
